import { FieldError, FieldErrors } from 'react-hook-form'

/**
 * Returns the field name for the given field key & optional parent dot path
 *
 * @param {string} fieldKey
 * @param {string} [parentDotPath]
 * @returns {string}
 */
export const getFieldName = (fieldKey: string, parentDotPath?: string): string => {
  return `${parentDotPath ? `${parentDotPath}.` : ''}${fieldKey}`
}

/**
 * Returns the field error message for the given field key & optional parent dot path
 *
 * @param {string} fieldKey
 * @param {string} [parentDotPath]
 * @param {FieldErrors} [errors]
 * @returns {FieldError | undefined}
 */
export const getFieldError = (fieldKey: string, parentDotPath?: string, errors?: FieldErrors): FieldError | undefined => {
  if (!errors) return undefined

  const keys = parentDotPath?.split('.')
  let result: FieldErrors | FieldError = errors

  if (keys) {
    for (const key of keys) {
      // Check if the key exists in the result object
      if (result === null || result === undefined || typeof result !== 'object') {
        return undefined
      }

      result = result[key]
    }
  }

  return result?.[fieldKey]
}
